const appVersion = process.env.GATSBY_APP_VERSION || 'development'

const auth0 = {
  domain: process.env.GATSBY_AUTH0_DOMAIN,
  clientId: process.env.GATSBY_AUTH0_CLIENT_ID,
  redirectUri: process.env.GATSBY_AUTH0_CALLBACK,
  audience: process.env.GATSBY_AUTH0_AUDIENCE,
}

const CURSOR_PREFIX = 'arrayconnection:'
const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_ACTIVE = 1
const DEFAULT_START_HOURS = 9

const POINT_TIME_BAND = [
  '09:00 ~ 10:00',
  '10:00 ~ 11:00',
  '11:00 ~ 12:00',
  '12:00 ~ 13:00',
  '13:00 ~ 14:00',
  '14:00 ~ 15:00',
  '15:00 ~ 16:00',
  '16:00 ~ 17:00',
  '17:00 ~ 18:00',
  '18:00 ~ 19:00',
  '19:00 ~ 20:00',
  '20:00 ~ 21:00',
]

const STORES = ['saga-aqua', 'saga-sta', 'saga-arena', 'saga-plaza']

/* 予約専用番号とSTOREごとのお問い合わせ番号 */
const PHONE_NUMBERS = {
  reservationOnly: "0952-37-1800",
  aqua: "0952-33-6119",
  sta: "0952-30-5311",
  arena: "0952-32-4070",
  plaza: "0952-32-2131"
}

interface DatePeriod {
  months: number | string
  days: number | string
  hours: number | string
}
/*　予約作成できる期間 */
const DEFAULT_PERIOD_ORDER_CREATE: DatePeriod = {
  months: 1,
  days: null,
  hours: null,
}
/*　予約更新・編集できる期間 */
const DEFAULT_PERIOD_ORDER_UPDATE: DatePeriod = {
  months: 1,
  days: null,
  hours: null,
}
/*　予約キャンセルできる期間 */
const DEFAULT_PERIOD_ORDER_CANCEL: DatePeriod = {
  months: 1,
  days: null,
  hours: null,
}

/* メールアドレス検証再送信画面に関する有効期間など */
const VERIFY_EMAIL_LIMATATION = {
  // 送信時間間隔、1分間
  sendMailCountDown: 60000,
  // 送られた検証 URL の有効期限、２４hours
  linkEffectiveDate: 24,
}

/* 消費税率 */
const TAX_RATE = 1.1

export {
  appVersion,
  auth0,
  CURSOR_PREFIX,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_ACTIVE,
  DEFAULT_START_HOURS,
  DEFAULT_PERIOD_ORDER_CREATE,
  DEFAULT_PERIOD_ORDER_UPDATE,
  DEFAULT_PERIOD_ORDER_CANCEL,
  POINT_TIME_BAND,
  PHONE_NUMBERS,
  STORES,
  TAX_RATE,
  VERIFY_EMAIL_LIMATATION,
}
